import { memo, useEffect, useRef } from 'react'
import { checkInputErrorMaxLength, checkInputErrorRequired, useTextarea } from '@chilecompra/react-kit'
import { Textarea } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { formatOnlyLettersNumbersAndSomeSymbols } from '../../modules/utils/formatters'
import { WhatHappening } from './RequestCreateInnovationForm.styles'

/**
 * The RequestCreateInnovationForm's whatHappening.
 */
const WhatHappeningSection = props => {
  const { descriptionProblem, isDisabled, onUpdate, submitError } = props

  const descriptionProblemRef = useRef(null)

  const conditionsFields = (collection = []) => collection.some(element => submitError?.includes(element))

  const {
    error: descriptionProblemError,
    onChange: handleDescriptionProblemChange,
    value: descriptionProblemValue
  } = useTextarea({
    changeCallback: updatedValue =>
      onUpdate({
        key: 'descriptionProblem',
        value: updatedValue
      }),
    errorCallbacks: [
      checkInputErrorRequired('Este campo es obligatorio. Debes completar esta información para poder continuar.'),
      checkInputErrorMaxLength(500)
    ],
    errorDependencies: [submitError],
    formatCallbacks: [formatOnlyLettersNumbersAndSomeSymbols],
    overwriteCallback: () => descriptionProblem
  })

  useEffect(() => {
    if (conditionsFields(['IS_INVESTIGATED_UNSET_ERROR', 'WILL_BE_REQUIRED_CONCEPT_UNSET_ERROR'])) return

    if (conditionsFields(['WHAT_HAPPENING_UNSET_ERROR', 'WHAT_HAPPENING_MAX_LENGTH_ERROR'])) {
      const element = descriptionProblemRef.current
      const headerOffset = 16
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      return window.scrollTo({
        top: offsetPosition
      })
    }
  }, [submitError])

  return (
    <WhatHappening>
      <Textarea
        disabled={isDisabled}
        error={descriptionProblemError}
        label="Descripción del problema"
        maxCount={500}
        onChange={handleDescriptionProblemChange}
        ref={descriptionProblemRef}
        required
        rows={4}
        value={descriptionProblemValue}
      />
    </WhatHappening>
  )
}

WhatHappeningSection.defaultProps = {
  isDisabled: false,
  submitError: undefined
}

WhatHappeningSection.propTypes = {
  descriptionProblem: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  submitError: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
}

export default memo(WhatHappeningSection)
